import ItemWrapper from '@/src/components/Layouts/Item/Item';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { Icon } from '@/src/tools/icon';
import { useRequest } from 'ahooks';
import { message } from 'antd';
import React from 'react';
import { Button, Form, TextArea } from 'src/components/Antd';
import { useI18n } from 'src/hooks/useRouterChange';
import {
  getDownloadAccess,
  updateDomain,
} from 'src/request/salesChannel/setting/miniProgramSetting';
import { convertRes2Blob, isHttpsURL } from 'src/tools/helper';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import css from '../css.module.less';
import styles from './css.module.less';
const MiniProgramWebviewDomainName = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [form] = Form.useForm();
  const { isBind, miniProgramUuid, iniData } = props;

  const [fold, setFold] = React.useState(false);

  const { run: _getAccess, loading } = useRequest(
    () => getDownloadAccess(miniProgramUuid),
    {
      manual: true,
      onSuccess: (res) => {
        convertRes2Blob(res);
        message.success(getI18n('general.done'));
      },
    },
  );

  const handleOnSubmit = (v) => {
    const { webViewDomains } = v;
    _uploadDomain({ webViewDomains: webViewDomains, uuid: miniProgramUuid });
  };

  const { run: _uploadDomain, loading: loading1 } = useRequest(
    (body) => updateDomain(body),
    {
      manual: true,
      onSuccess: (res) => {
        message.success(getI18n('general.done'));
      },
    },
  );

  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.logoWrapper}
      titleOnClick={() => setFold(!fold)}
      hideContent={!fold}
      rightPart={<Icon type={fold ? 'icondown1' : 'iconright'} />}
      title={getI18n(
        'salesChannelMiniProgramSettings.index.miniProgramWebviewDomainNames',
      )}
      subtitle={getI18n(
        'salesChannelMiniProgramSettings.index.miniProgramWebviewDomainNamesTip',
      )}>
      {' '}
      <ItemWrapper
        title={getI18n(
          'salesChannelMiniProgramSettings.index.domainNameStep1',
        )}>
        <Button
          type='primary'
          disabled={!isBind}
          loading={loading}
          onClick={_getAccess}>
          {getI18n('general.download')}
        </Button>
      </ItemWrapper>
      <Form
        form={form}
        onFinish={handleOnSubmit}
        initialValues={{ webViewDomains: iniData }}>
        <ItemWrapper
          belowComponentTitle={
            <React.Fragment>
              <div className={styles.maxTip}>
                {getI18n('salesChannelMiniProgramSettings.index.maxTip')}
              </div>{' '}
              <Button
                type='primary'
                disabled={!isBind}
                onClick={() => {
                  form.submit();
                }}
                loading={loading1}>
                {getI18n('salesChannelMiniProgramSettings.index.submit')}
              </Button>
            </React.Fragment>
          }
          title={getI18n(
            'salesChannelMiniProgramSettings.index.domainNameStep2',
          )}>
          <Form.Item
            name='webViewDomains'
            rules={[
              { required: true, message: getI18n('general.fieldCannotEmpty') },
              {
                validator: async (_, values) => {
                  if (values) {
                    const domains = values.split(';');
                    if (domains.length > 200) {
                      return Promise.reject(
                        new Error(
                          getI18n(
                            'salesChannelMiniProgramSettings.index.maximumof200domainnames',
                          ),
                        ),
                      );
                    }
                    const empty = [];
                    const formatErr = [];
                    domains.forEach((i, index) => {
                      if ((i || '').length < 1) {
                        empty.push(index);
                      } else {
                        const v = isHttpsURL(i);
                        if (!v) {
                          formatErr.push(index);
                        }
                      }
                    });
                    if (empty.length > 0 || formatErr.length > 0) {
                      const i = [...empty, ...formatErr];
                      const iPlus = i.map((i) => i + 1);
                      return Promise.reject(
                        new Error(
                          replaceI18nVariables(
                            getI18n(
                              'salesChannelMiniProgramSettings.index.errorformat',
                            ),
                            iPlus.join(','),
                          ),
                        ),
                      );
                    }
                  }
                },
              },
            ]}>
            <TextArea
              autoSize={{ minRows: 5, maxRows: 10 }}
              disabled={!isBind}
            />
          </Form.Item>
        </ItemWrapper>
      </Form>
    </SectionWrapper>
  );
};
export default MiniProgramWebviewDomainName;
